import React from "react";
import { LimitedList } from "../../../../../limitedList/limitedList";
import styles from "../../../tagName/tagsList.css";
import { MessageWidgetName } from "./messageWidgetName";
import { IMessageWidgetConfig } from "../../../../../../models/messageWidgets/MessageWidgetConfig";

const ROW_HEIGHT = 20;
const CONTAINER_MAX_HEIGHT = 58; // in line with max-height in `tagsList.css`

interface Props {
  messageWidget?: IMessageWidgetConfig[];
  onActionDelete?(tagId: string): void;
}

export const MessageWidgetList = ({ messageWidget, onActionDelete }: Props) => {
  const renderTags = (elements: IMessageWidgetConfig[]) => {
    return elements.map((action) => (
      <MessageWidgetName
        isActive
        key={action.id}
        name={action.name}
        onDelete={onActionDelete ? () => onActionDelete(action.id) : undefined}
      />
    ));
  };

  return (
    <LimitedList
      maxHeight={CONTAINER_MAX_HEIGHT}
      rowHeight={ROW_HEIGHT}
      className={styles.container}
    >
      {messageWidget && !!messageWidget.length && renderTags(messageWidget)}
    </LimitedList>
  );
};
